// removed by extract-text-webpack-plugin
module.exports = {"filter":"_1YKkZSY4bRzpdTND9tSypS","active":"_2An7ooiglAk4hMCh2GQdRp"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Profile/Pages/Inscriptions/style.module.css
// module id = 501
// module chunks = 38